<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="edit-job">
  <div class="edit-job-header">
    <div class="edit-job-header-title">{{ job?.name }}</div>

    <mat-button-toggle-group
      (change)="onSectionChange($event.value)"
      [value]="EditJobSection.TASKS"
      class="edit-job-toggler"
      name="section"
      aria-label="Section"
    >
      <mat-button-toggle [value]="EditJobSection.TASKS">
        <mat-icon *ngIf="section !== EditJobSection.TASKS">list</mat-icon>
        <span>Tasks</span>
      </mat-button-toggle>

      <mat-button-toggle [value]="EditJobSection.LOIS">
        <mat-icon *ngIf="section !== EditJobSection.LOIS">place</mat-icon>
        <span>Sites</span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div [ngSwitch]="section">
    <div *ngSwitchCase="EditJobSection.LOIS">
      <loi-editor
        *ngIf="draftSurveyService.getSurvey$() | async as survey"
        [canImport]="surveyService.canManageSurvey()"
        [survey]="survey"
        [job]="job"
        [lois]="lois"
        (updateStrategy)="onStrategyChange($event)"
        #loiEditor
      />
    </div>

    <div *ngSwitchCase="EditJobSection.TASKS">
      <tasks-editor
        [tasks]="tasks"
        (onValueChanges)="onTasksChange($event)"
        #tasksEditor
      >
      </tasks-editor>
    </div>
  </div>
</div>
